var loginEmailController = {
    loginModal: $('#loginModal'),
    elForm: $('#loginEmail'),
    email: '',
    password: '',
    init: function()
    {
        loginEmailController.elForm.find('.error-text').hide();

        loginEmailController.email = loginEmailController.elForm.find('.js-input-email').val();
        loginEmailController.password = loginEmailController.elForm.find('.js-input-password').val();

        loginEmailController.elForm.find('.js-input-email').on('click change keyup blur input', function(){
            loginEmailController.email = $(this).val().trim();
        });

        loginEmailController.elForm.find('.js-input-password').on('click change keyup blur input', function(){
            loginEmailController.password = $(this).val().trim();
        });

        loginEmailController.elForm.find('button').on('click', function() {
            loginEmailController.submitForm();

            return false;
        });
    },
    submitForm: function()
    {
        if (!loginEmailController.validateForm()) {
            loginEmailController.showError();

            return false;
        }

        $.post(
            loginEmailController.elForm.attr('action'),
            loginEmailController.elForm.serialize(),
            function(data){
                if (data.success) {
                    const cachedData = localStorage.getItem('checkAuth');
                    if(cachedData) {
                        localStorage.setItem('checkAuth', cachedData+1);
                    } else {
                        localStorage.setItem('checkAuth', 1);
                    }

                    // _tmr.push({ type: 'reachGoal', id: 3420720, goal: 'authorization'});
                    // ym(76611819,'reachGoal','authorization');

                    if (conversionDeferredEvent.isSetConversion()) {
                        conversionDeferredEvent.triggerEvent();
                    }

                    window.location.href = URL_CONST.LOGIN_REDIRECT;
                } else {
                    loginEmailController.showError();
                }
            }, 'json');
    },
    validateForm: function()
    {
        loginEmailController.clearForm();
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return (loginEmailController.email.length > 3 && regex.test(loginEmailController.email) && loginEmailController.password.length > 5);
    },
    clearForm: function()
    {
        loginEmailController.elForm.find('.form-group').removeClass('has-error');
        loginEmailController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        loginEmailController.elForm.find('.form-group').addClass('has-error');
        loginEmailController.elForm.find('.error-text').show();
    }
};

$(function(){
    loginEmailController.init();
});
